module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-03.3230052a78d51d97a5d0bc88ef96e1b1.png";